/* tslint:disable */
/* eslint-disable */
/**
 * FanFair Complete API
 * Complete API documentation for FanFair platform including both public and private endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AddAuthTokenRequest } from '../models';
// @ts-ignore
import type { AuthTokenListResponse } from '../models';
// @ts-ignore
import type { AuthTokenVersionResponse } from '../models';
// @ts-ignore
import type { CreateGatewayConfigurationRequest } from '../models';
// @ts-ignore
import type { ErrorResponse } from '../models';
// @ts-ignore
import type { GatewayConfigurationResponse } from '../models';
// @ts-ignore
import type { GatewayProcessorCredentials } from '../models';
// @ts-ignore
import type { PatchGatewayConfigurationV1Request } from '../models';
// @ts-ignore
import type { PromoteResult } from '../models';
/**
 * GatewayConfigurationsApi - axios parameter creator
 * @export
 */
export const GatewayConfigurationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create a payment gateway configuration for a partner
         * @summary Create a gateway configuration
         * @param {string} partnerId 
         * @param {CreateGatewayConfigurationRequest} createGatewayConfigurationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createGatewayConfigurationV1: async (partnerId: string, createGatewayConfigurationRequest: CreateGatewayConfigurationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'partnerId' is not null or undefined
            assertParamExists('createGatewayConfigurationV1', 'partnerId', partnerId)
            // verify required parameter 'createGatewayConfigurationRequest' is not null or undefined
            assertParamExists('createGatewayConfigurationV1', 'createGatewayConfigurationRequest', createGatewayConfigurationRequest)
            const localVarPath = `/api/v1/partners/{partnerId}/gateway-configurations`
                .replace(`{${"partnerId"}}`, encodeURIComponent(String(partnerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createGatewayConfigurationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Remove a `STANDBY` or `RETIRED` `authToken` version from a PROPAY gateway configuration. The `LIVE` token can never be deleted — the server rejects with 409 `CANNOT_DELETE_LIVE_TOKEN` and the UI should hide the action. 
         * @summary Delete a STANDBY or RETIRED ProPay authToken version
         * @param {string} partnerId 
         * @param {string} configId 
         * @param {string} tokenId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteGatewayAuthTokenV1: async (partnerId: string, configId: string, tokenId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'partnerId' is not null or undefined
            assertParamExists('deleteGatewayAuthTokenV1', 'partnerId', partnerId)
            // verify required parameter 'configId' is not null or undefined
            assertParamExists('deleteGatewayAuthTokenV1', 'configId', configId)
            // verify required parameter 'tokenId' is not null or undefined
            assertParamExists('deleteGatewayAuthTokenV1', 'tokenId', tokenId)
            const localVarPath = `/api/v1/partners/{partnerId}/gateway-configurations/{configId}/auth-tokens/{tokenId}`
                .replace(`{${"partnerId"}}`, encodeURIComponent(String(partnerId)))
                .replace(`{${"configId"}}`, encodeURIComponent(String(configId)))
                .replace(`{${"tokenId"}}`, encodeURIComponent(String(tokenId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a gateway configuration for a partner. The associated encrypted credentials in the vault are purged as part of the same operation.  Any Fiserv payee-application history for the configuration is removed with it: each application row is retained in an internal audit record and deleted in the same operation, so onboarding history never blocks the delete.  Rejected with 409 while at least one of the partner\'s merchants is still boarded to the configuration\'s processor — disconnect or migrate those merchants first — or when another resource still references the configuration. 
         * @summary Delete gateway configuration
         * @param {string} partnerId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteGatewayConfigurationV1: async (partnerId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'partnerId' is not null or undefined
            assertParamExists('deleteGatewayConfigurationV1', 'partnerId', partnerId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteGatewayConfigurationV1', 'id', id)
            const localVarPath = `/api/v1/partners/{partnerId}/gateway-configurations/{id}`
                .replace(`{${"partnerId"}}`, encodeURIComponent(String(partnerId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a specific gateway configuration for a partner
         * @summary Get gateway configuration
         * @param {string} partnerId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGatewayConfigurationV1: async (partnerId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'partnerId' is not null or undefined
            assertParamExists('getGatewayConfigurationV1', 'partnerId', partnerId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getGatewayConfigurationV1', 'id', id)
            const localVarPath = `/api/v1/partners/{partnerId}/gateway-configurations/{id}`
                .replace(`{${"partnerId"}}`, encodeURIComponent(String(partnerId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all gateway configurations for a partner
         * @summary Get partner\'s gateway configurations
         * @param {string} partnerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGatewayConfigurationsV1: async (partnerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'partnerId' is not null or undefined
            assertParamExists('getGatewayConfigurationsV1', 'partnerId', partnerId)
            const localVarPath = `/api/v1/partners/{partnerId}/gateway-configurations`
                .replace(`{${"partnerId"}}`, encodeURIComponent(String(partnerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve payment gateway credentials for a partner. This endpoint is intended for service-to-service communication and requires OAuth scope service.partner.gateway:read.  The credentials are decrypted and returned in plain text for use by calling services. These credentials should be cached by the calling service with appropriate TTL. 
         * @summary Get partner gateway credentials
         * @param {string} partnerId Partner identifier
         * @param {string} [xCorrelationID] Optional correlation ID for request tracking
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartnerGatewayCredentials: async (partnerId: string, xCorrelationID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'partnerId' is not null or undefined
            assertParamExists('getPartnerGatewayCredentials', 'partnerId', partnerId)
            const localVarPath = `/api/v1/partners/{partnerId}/gateway-credentials`
                .replace(`{${"partnerId"}}`, encodeURIComponent(String(partnerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (xCorrelationID != null) {
                localVarHeaderParameter['X-Correlation-ID'] = String(xCorrelationID);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return the full list of `authToken` versions for a PROPAY gateway configuration, with each token value masked (last 4 characters revealed). Exactly one entry has `status = LIVE` in normal operation.  Only applicable to PROPAY gateways — 404 if the configuration is GENERIC or FISERV_FORWARD (which do not have a versioned auth-token model). 
         * @summary List authToken versions for a PROPAY gateway
         * @param {string} partnerId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listGatewayAuthTokensV1: async (partnerId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'partnerId' is not null or undefined
            assertParamExists('listGatewayAuthTokensV1', 'partnerId', partnerId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('listGatewayAuthTokensV1', 'id', id)
            const localVarPath = `/api/v1/partners/{partnerId}/gateway-configurations/{id}/auth-tokens`
                .replace(`{${"partnerId"}}`, encodeURIComponent(String(partnerId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Merge-style partial update of a PROPAY gateway configuration. Only the fields present in the request body are touched; omitted fields are preserved as-is.  Three-state semantics on each whitelisted field:  - **Absent** — key not in the body → field untouched. - **Explicit `null`** — only legal for nullable fields   (`receivingAccountId`, `payoutAccountId`); clears the column. - **Value** — validated and applied. Required fields (`termId`,   `certStr`, `billerId`) reject an explicit `null` with 400.  `authToken` rotation is out of scope — it lives on the dedicated `POST .../auth-tokens` + `POST .../auth-tokens/{tokenId}/promote` endpoints. Sending `authToken` in this body returns 400.  Unknown keys and empty bodies are rejected with 400.  **FISERV_FORWARD** configurations accept exactly one key, `authFeeCents` (see `PatchFiservForwardGatewayConfigurationRequest`). Sending it on a PROPAY or GENERIC configuration, or sending a credential field on a Forward configuration, returns 400. GENERIC gateways have no patchable field and return 409. 
         * @summary Patch gateway configuration (PROPAY only)
         * @param {string} partnerId 
         * @param {string} id 
         * @param {PatchGatewayConfigurationV1Request} patchGatewayConfigurationV1Request 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchGatewayConfigurationV1: async (partnerId: string, id: string, patchGatewayConfigurationV1Request: PatchGatewayConfigurationV1Request, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'partnerId' is not null or undefined
            assertParamExists('patchGatewayConfigurationV1', 'partnerId', partnerId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('patchGatewayConfigurationV1', 'id', id)
            // verify required parameter 'patchGatewayConfigurationV1Request' is not null or undefined
            assertParamExists('patchGatewayConfigurationV1', 'patchGatewayConfigurationV1Request', patchGatewayConfigurationV1Request)
            const localVarPath = `/api/v1/partners/{partnerId}/gateway-configurations/{id}`
                .replace(`{${"partnerId"}}`, encodeURIComponent(String(partnerId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchGatewayConfigurationV1Request, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Atomically demote the current `LIVE` token to `RETIRED` and set the target token `LIVE`. Because the previous token is preserved as `RETIRED`, rollback is simply a promote of that retired token — there is no separate rollback endpoint.  Idempotent: promoting the already-LIVE token returns 200 with `previousLiveTokenId = null` and does not create a spurious RETIRED row.  Concurrency: two concurrent promotes on the same gateway serialise; the second observes the first\'s committed state and either becomes a no-op (when the winner already set its target LIVE) or promotes on top of the winner. 
         * @summary Promote a ProPay authToken to LIVE (rollback is a promote of the RETIRED token)
         * @param {string} partnerId 
         * @param {string} configId 
         * @param {string} tokenId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        promoteGatewayAuthTokenV1: async (partnerId: string, configId: string, tokenId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'partnerId' is not null or undefined
            assertParamExists('promoteGatewayAuthTokenV1', 'partnerId', partnerId)
            // verify required parameter 'configId' is not null or undefined
            assertParamExists('promoteGatewayAuthTokenV1', 'configId', configId)
            // verify required parameter 'tokenId' is not null or undefined
            assertParamExists('promoteGatewayAuthTokenV1', 'tokenId', tokenId)
            const localVarPath = `/api/v1/partners/{partnerId}/gateway-configurations/{configId}/auth-tokens/{tokenId}/promote`
                .replace(`{${"partnerId"}}`, encodeURIComponent(String(partnerId)))
                .replace(`{${"configId"}}`, encodeURIComponent(String(configId)))
                .replace(`{${"tokenId"}}`, encodeURIComponent(String(tokenId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Register a new ProPay `authToken` as a `STANDBY` version on this PROPAY gateway configuration. The current `LIVE` token is left untouched — every payment, void, refund, and onboarding call continues to resolve `LIVE` until an explicit promote. Multiple STANDBY rows may coexist; the single-LIVE invariant is unaffected.  Only applicable to PROPAY gateways. Duplicate token values (compared against ALL existing versions on this gateway — LIVE, STANDBY, and RETIRED) are rejected with 409 to prevent an operator from re-adding a value that was already recorded on this credential. 
         * @summary Rotate ProPay authToken (add STANDBY)
         * @param {string} partnerId 
         * @param {string} id 
         * @param {AddAuthTokenRequest} addAuthTokenRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rotateGatewayAuthTokenV1: async (partnerId: string, id: string, addAuthTokenRequest: AddAuthTokenRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'partnerId' is not null or undefined
            assertParamExists('rotateGatewayAuthTokenV1', 'partnerId', partnerId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('rotateGatewayAuthTokenV1', 'id', id)
            // verify required parameter 'addAuthTokenRequest' is not null or undefined
            assertParamExists('rotateGatewayAuthTokenV1', 'addAuthTokenRequest', addAuthTokenRequest)
            const localVarPath = `/api/v1/partners/{partnerId}/gateway-configurations/{id}/auth-tokens`
                .replace(`{${"partnerId"}}`, encodeURIComponent(String(partnerId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addAuthTokenRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GatewayConfigurationsApi - functional programming interface
 * @export
 */
export const GatewayConfigurationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GatewayConfigurationsApiAxiosParamCreator(configuration)
    return {
        /**
         * Create a payment gateway configuration for a partner
         * @summary Create a gateway configuration
         * @param {string} partnerId 
         * @param {CreateGatewayConfigurationRequest} createGatewayConfigurationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createGatewayConfigurationV1(partnerId: string, createGatewayConfigurationRequest: CreateGatewayConfigurationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GatewayConfigurationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createGatewayConfigurationV1(partnerId, createGatewayConfigurationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GatewayConfigurationsApi.createGatewayConfigurationV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Remove a `STANDBY` or `RETIRED` `authToken` version from a PROPAY gateway configuration. The `LIVE` token can never be deleted — the server rejects with 409 `CANNOT_DELETE_LIVE_TOKEN` and the UI should hide the action. 
         * @summary Delete a STANDBY or RETIRED ProPay authToken version
         * @param {string} partnerId 
         * @param {string} configId 
         * @param {string} tokenId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteGatewayAuthTokenV1(partnerId: string, configId: string, tokenId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteGatewayAuthTokenV1(partnerId, configId, tokenId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GatewayConfigurationsApi.deleteGatewayAuthTokenV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a gateway configuration for a partner. The associated encrypted credentials in the vault are purged as part of the same operation.  Any Fiserv payee-application history for the configuration is removed with it: each application row is retained in an internal audit record and deleted in the same operation, so onboarding history never blocks the delete.  Rejected with 409 while at least one of the partner\'s merchants is still boarded to the configuration\'s processor — disconnect or migrate those merchants first — or when another resource still references the configuration. 
         * @summary Delete gateway configuration
         * @param {string} partnerId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteGatewayConfigurationV1(partnerId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteGatewayConfigurationV1(partnerId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GatewayConfigurationsApi.deleteGatewayConfigurationV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a specific gateway configuration for a partner
         * @summary Get gateway configuration
         * @param {string} partnerId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGatewayConfigurationV1(partnerId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GatewayConfigurationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGatewayConfigurationV1(partnerId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GatewayConfigurationsApi.getGatewayConfigurationV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all gateway configurations for a partner
         * @summary Get partner\'s gateway configurations
         * @param {string} partnerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGatewayConfigurationsV1(partnerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GatewayConfigurationResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGatewayConfigurationsV1(partnerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GatewayConfigurationsApi.getGatewayConfigurationsV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve payment gateway credentials for a partner. This endpoint is intended for service-to-service communication and requires OAuth scope service.partner.gateway:read.  The credentials are decrypted and returned in plain text for use by calling services. These credentials should be cached by the calling service with appropriate TTL. 
         * @summary Get partner gateway credentials
         * @param {string} partnerId Partner identifier
         * @param {string} [xCorrelationID] Optional correlation ID for request tracking
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPartnerGatewayCredentials(partnerId: string, xCorrelationID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GatewayProcessorCredentials>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPartnerGatewayCredentials(partnerId, xCorrelationID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GatewayConfigurationsApi.getPartnerGatewayCredentials']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Return the full list of `authToken` versions for a PROPAY gateway configuration, with each token value masked (last 4 characters revealed). Exactly one entry has `status = LIVE` in normal operation.  Only applicable to PROPAY gateways — 404 if the configuration is GENERIC or FISERV_FORWARD (which do not have a versioned auth-token model). 
         * @summary List authToken versions for a PROPAY gateway
         * @param {string} partnerId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listGatewayAuthTokensV1(partnerId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthTokenListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listGatewayAuthTokensV1(partnerId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GatewayConfigurationsApi.listGatewayAuthTokensV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Merge-style partial update of a PROPAY gateway configuration. Only the fields present in the request body are touched; omitted fields are preserved as-is.  Three-state semantics on each whitelisted field:  - **Absent** — key not in the body → field untouched. - **Explicit `null`** — only legal for nullable fields   (`receivingAccountId`, `payoutAccountId`); clears the column. - **Value** — validated and applied. Required fields (`termId`,   `certStr`, `billerId`) reject an explicit `null` with 400.  `authToken` rotation is out of scope — it lives on the dedicated `POST .../auth-tokens` + `POST .../auth-tokens/{tokenId}/promote` endpoints. Sending `authToken` in this body returns 400.  Unknown keys and empty bodies are rejected with 400.  **FISERV_FORWARD** configurations accept exactly one key, `authFeeCents` (see `PatchFiservForwardGatewayConfigurationRequest`). Sending it on a PROPAY or GENERIC configuration, or sending a credential field on a Forward configuration, returns 400. GENERIC gateways have no patchable field and return 409. 
         * @summary Patch gateway configuration (PROPAY only)
         * @param {string} partnerId 
         * @param {string} id 
         * @param {PatchGatewayConfigurationV1Request} patchGatewayConfigurationV1Request 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchGatewayConfigurationV1(partnerId: string, id: string, patchGatewayConfigurationV1Request: PatchGatewayConfigurationV1Request, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GatewayConfigurationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchGatewayConfigurationV1(partnerId, id, patchGatewayConfigurationV1Request, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GatewayConfigurationsApi.patchGatewayConfigurationV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Atomically demote the current `LIVE` token to `RETIRED` and set the target token `LIVE`. Because the previous token is preserved as `RETIRED`, rollback is simply a promote of that retired token — there is no separate rollback endpoint.  Idempotent: promoting the already-LIVE token returns 200 with `previousLiveTokenId = null` and does not create a spurious RETIRED row.  Concurrency: two concurrent promotes on the same gateway serialise; the second observes the first\'s committed state and either becomes a no-op (when the winner already set its target LIVE) or promotes on top of the winner. 
         * @summary Promote a ProPay authToken to LIVE (rollback is a promote of the RETIRED token)
         * @param {string} partnerId 
         * @param {string} configId 
         * @param {string} tokenId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async promoteGatewayAuthTokenV1(partnerId: string, configId: string, tokenId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PromoteResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.promoteGatewayAuthTokenV1(partnerId, configId, tokenId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GatewayConfigurationsApi.promoteGatewayAuthTokenV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Register a new ProPay `authToken` as a `STANDBY` version on this PROPAY gateway configuration. The current `LIVE` token is left untouched — every payment, void, refund, and onboarding call continues to resolve `LIVE` until an explicit promote. Multiple STANDBY rows may coexist; the single-LIVE invariant is unaffected.  Only applicable to PROPAY gateways. Duplicate token values (compared against ALL existing versions on this gateway — LIVE, STANDBY, and RETIRED) are rejected with 409 to prevent an operator from re-adding a value that was already recorded on this credential. 
         * @summary Rotate ProPay authToken (add STANDBY)
         * @param {string} partnerId 
         * @param {string} id 
         * @param {AddAuthTokenRequest} addAuthTokenRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rotateGatewayAuthTokenV1(partnerId: string, id: string, addAuthTokenRequest: AddAuthTokenRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthTokenVersionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rotateGatewayAuthTokenV1(partnerId, id, addAuthTokenRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GatewayConfigurationsApi.rotateGatewayAuthTokenV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * GatewayConfigurationsApi - factory interface
 * @export
 */
export const GatewayConfigurationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GatewayConfigurationsApiFp(configuration)
    return {
        /**
         * Create a payment gateway configuration for a partner
         * @summary Create a gateway configuration
         * @param {string} partnerId 
         * @param {CreateGatewayConfigurationRequest} createGatewayConfigurationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createGatewayConfigurationV1(partnerId: string, createGatewayConfigurationRequest: CreateGatewayConfigurationRequest, options?: RawAxiosRequestConfig): AxiosPromise<GatewayConfigurationResponse> {
            return localVarFp.createGatewayConfigurationV1(partnerId, createGatewayConfigurationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Remove a `STANDBY` or `RETIRED` `authToken` version from a PROPAY gateway configuration. The `LIVE` token can never be deleted — the server rejects with 409 `CANNOT_DELETE_LIVE_TOKEN` and the UI should hide the action. 
         * @summary Delete a STANDBY or RETIRED ProPay authToken version
         * @param {string} partnerId 
         * @param {string} configId 
         * @param {string} tokenId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteGatewayAuthTokenV1(partnerId: string, configId: string, tokenId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteGatewayAuthTokenV1(partnerId, configId, tokenId, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a gateway configuration for a partner. The associated encrypted credentials in the vault are purged as part of the same operation.  Any Fiserv payee-application history for the configuration is removed with it: each application row is retained in an internal audit record and deleted in the same operation, so onboarding history never blocks the delete.  Rejected with 409 while at least one of the partner\'s merchants is still boarded to the configuration\'s processor — disconnect or migrate those merchants first — or when another resource still references the configuration. 
         * @summary Delete gateway configuration
         * @param {string} partnerId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteGatewayConfigurationV1(partnerId: string, id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteGatewayConfigurationV1(partnerId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a specific gateway configuration for a partner
         * @summary Get gateway configuration
         * @param {string} partnerId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGatewayConfigurationV1(partnerId: string, id: string, options?: RawAxiosRequestConfig): AxiosPromise<GatewayConfigurationResponse> {
            return localVarFp.getGatewayConfigurationV1(partnerId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all gateway configurations for a partner
         * @summary Get partner\'s gateway configurations
         * @param {string} partnerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGatewayConfigurationsV1(partnerId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<GatewayConfigurationResponse>> {
            return localVarFp.getGatewayConfigurationsV1(partnerId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve payment gateway credentials for a partner. This endpoint is intended for service-to-service communication and requires OAuth scope service.partner.gateway:read.  The credentials are decrypted and returned in plain text for use by calling services. These credentials should be cached by the calling service with appropriate TTL. 
         * @summary Get partner gateway credentials
         * @param {string} partnerId Partner identifier
         * @param {string} [xCorrelationID] Optional correlation ID for request tracking
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartnerGatewayCredentials(partnerId: string, xCorrelationID?: string, options?: RawAxiosRequestConfig): AxiosPromise<GatewayProcessorCredentials> {
            return localVarFp.getPartnerGatewayCredentials(partnerId, xCorrelationID, options).then((request) => request(axios, basePath));
        },
        /**
         * Return the full list of `authToken` versions for a PROPAY gateway configuration, with each token value masked (last 4 characters revealed). Exactly one entry has `status = LIVE` in normal operation.  Only applicable to PROPAY gateways — 404 if the configuration is GENERIC or FISERV_FORWARD (which do not have a versioned auth-token model). 
         * @summary List authToken versions for a PROPAY gateway
         * @param {string} partnerId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listGatewayAuthTokensV1(partnerId: string, id: string, options?: RawAxiosRequestConfig): AxiosPromise<AuthTokenListResponse> {
            return localVarFp.listGatewayAuthTokensV1(partnerId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * Merge-style partial update of a PROPAY gateway configuration. Only the fields present in the request body are touched; omitted fields are preserved as-is.  Three-state semantics on each whitelisted field:  - **Absent** — key not in the body → field untouched. - **Explicit `null`** — only legal for nullable fields   (`receivingAccountId`, `payoutAccountId`); clears the column. - **Value** — validated and applied. Required fields (`termId`,   `certStr`, `billerId`) reject an explicit `null` with 400.  `authToken` rotation is out of scope — it lives on the dedicated `POST .../auth-tokens` + `POST .../auth-tokens/{tokenId}/promote` endpoints. Sending `authToken` in this body returns 400.  Unknown keys and empty bodies are rejected with 400.  **FISERV_FORWARD** configurations accept exactly one key, `authFeeCents` (see `PatchFiservForwardGatewayConfigurationRequest`). Sending it on a PROPAY or GENERIC configuration, or sending a credential field on a Forward configuration, returns 400. GENERIC gateways have no patchable field and return 409. 
         * @summary Patch gateway configuration (PROPAY only)
         * @param {string} partnerId 
         * @param {string} id 
         * @param {PatchGatewayConfigurationV1Request} patchGatewayConfigurationV1Request 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchGatewayConfigurationV1(partnerId: string, id: string, patchGatewayConfigurationV1Request: PatchGatewayConfigurationV1Request, options?: RawAxiosRequestConfig): AxiosPromise<GatewayConfigurationResponse> {
            return localVarFp.patchGatewayConfigurationV1(partnerId, id, patchGatewayConfigurationV1Request, options).then((request) => request(axios, basePath));
        },
        /**
         * Atomically demote the current `LIVE` token to `RETIRED` and set the target token `LIVE`. Because the previous token is preserved as `RETIRED`, rollback is simply a promote of that retired token — there is no separate rollback endpoint.  Idempotent: promoting the already-LIVE token returns 200 with `previousLiveTokenId = null` and does not create a spurious RETIRED row.  Concurrency: two concurrent promotes on the same gateway serialise; the second observes the first\'s committed state and either becomes a no-op (when the winner already set its target LIVE) or promotes on top of the winner. 
         * @summary Promote a ProPay authToken to LIVE (rollback is a promote of the RETIRED token)
         * @param {string} partnerId 
         * @param {string} configId 
         * @param {string} tokenId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        promoteGatewayAuthTokenV1(partnerId: string, configId: string, tokenId: string, options?: RawAxiosRequestConfig): AxiosPromise<PromoteResult> {
            return localVarFp.promoteGatewayAuthTokenV1(partnerId, configId, tokenId, options).then((request) => request(axios, basePath));
        },
        /**
         * Register a new ProPay `authToken` as a `STANDBY` version on this PROPAY gateway configuration. The current `LIVE` token is left untouched — every payment, void, refund, and onboarding call continues to resolve `LIVE` until an explicit promote. Multiple STANDBY rows may coexist; the single-LIVE invariant is unaffected.  Only applicable to PROPAY gateways. Duplicate token values (compared against ALL existing versions on this gateway — LIVE, STANDBY, and RETIRED) are rejected with 409 to prevent an operator from re-adding a value that was already recorded on this credential. 
         * @summary Rotate ProPay authToken (add STANDBY)
         * @param {string} partnerId 
         * @param {string} id 
         * @param {AddAuthTokenRequest} addAuthTokenRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rotateGatewayAuthTokenV1(partnerId: string, id: string, addAuthTokenRequest: AddAuthTokenRequest, options?: RawAxiosRequestConfig): AxiosPromise<AuthTokenVersionResponse> {
            return localVarFp.rotateGatewayAuthTokenV1(partnerId, id, addAuthTokenRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * GatewayConfigurationsApi - object-oriented interface
 * @export
 * @class GatewayConfigurationsApi
 * @extends {BaseAPI}
 */
export class GatewayConfigurationsApi extends BaseAPI {
    /**
     * Create a payment gateway configuration for a partner
     * @summary Create a gateway configuration
     * @param {string} partnerId 
     * @param {CreateGatewayConfigurationRequest} createGatewayConfigurationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GatewayConfigurationsApi
     */
    public createGatewayConfigurationV1(partnerId: string, createGatewayConfigurationRequest: CreateGatewayConfigurationRequest, options?: RawAxiosRequestConfig) {
        return GatewayConfigurationsApiFp(this.configuration).createGatewayConfigurationV1(partnerId, createGatewayConfigurationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Remove a `STANDBY` or `RETIRED` `authToken` version from a PROPAY gateway configuration. The `LIVE` token can never be deleted — the server rejects with 409 `CANNOT_DELETE_LIVE_TOKEN` and the UI should hide the action. 
     * @summary Delete a STANDBY or RETIRED ProPay authToken version
     * @param {string} partnerId 
     * @param {string} configId 
     * @param {string} tokenId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GatewayConfigurationsApi
     */
    public deleteGatewayAuthTokenV1(partnerId: string, configId: string, tokenId: string, options?: RawAxiosRequestConfig) {
        return GatewayConfigurationsApiFp(this.configuration).deleteGatewayAuthTokenV1(partnerId, configId, tokenId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a gateway configuration for a partner. The associated encrypted credentials in the vault are purged as part of the same operation.  Any Fiserv payee-application history for the configuration is removed with it: each application row is retained in an internal audit record and deleted in the same operation, so onboarding history never blocks the delete.  Rejected with 409 while at least one of the partner\'s merchants is still boarded to the configuration\'s processor — disconnect or migrate those merchants first — or when another resource still references the configuration. 
     * @summary Delete gateway configuration
     * @param {string} partnerId 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GatewayConfigurationsApi
     */
    public deleteGatewayConfigurationV1(partnerId: string, id: string, options?: RawAxiosRequestConfig) {
        return GatewayConfigurationsApiFp(this.configuration).deleteGatewayConfigurationV1(partnerId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a specific gateway configuration for a partner
     * @summary Get gateway configuration
     * @param {string} partnerId 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GatewayConfigurationsApi
     */
    public getGatewayConfigurationV1(partnerId: string, id: string, options?: RawAxiosRequestConfig) {
        return GatewayConfigurationsApiFp(this.configuration).getGatewayConfigurationV1(partnerId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all gateway configurations for a partner
     * @summary Get partner\'s gateway configurations
     * @param {string} partnerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GatewayConfigurationsApi
     */
    public getGatewayConfigurationsV1(partnerId: string, options?: RawAxiosRequestConfig) {
        return GatewayConfigurationsApiFp(this.configuration).getGatewayConfigurationsV1(partnerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve payment gateway credentials for a partner. This endpoint is intended for service-to-service communication and requires OAuth scope service.partner.gateway:read.  The credentials are decrypted and returned in plain text for use by calling services. These credentials should be cached by the calling service with appropriate TTL. 
     * @summary Get partner gateway credentials
     * @param {string} partnerId Partner identifier
     * @param {string} [xCorrelationID] Optional correlation ID for request tracking
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GatewayConfigurationsApi
     */
    public getPartnerGatewayCredentials(partnerId: string, xCorrelationID?: string, options?: RawAxiosRequestConfig) {
        return GatewayConfigurationsApiFp(this.configuration).getPartnerGatewayCredentials(partnerId, xCorrelationID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return the full list of `authToken` versions for a PROPAY gateway configuration, with each token value masked (last 4 characters revealed). Exactly one entry has `status = LIVE` in normal operation.  Only applicable to PROPAY gateways — 404 if the configuration is GENERIC or FISERV_FORWARD (which do not have a versioned auth-token model). 
     * @summary List authToken versions for a PROPAY gateway
     * @param {string} partnerId 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GatewayConfigurationsApi
     */
    public listGatewayAuthTokensV1(partnerId: string, id: string, options?: RawAxiosRequestConfig) {
        return GatewayConfigurationsApiFp(this.configuration).listGatewayAuthTokensV1(partnerId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Merge-style partial update of a PROPAY gateway configuration. Only the fields present in the request body are touched; omitted fields are preserved as-is.  Three-state semantics on each whitelisted field:  - **Absent** — key not in the body → field untouched. - **Explicit `null`** — only legal for nullable fields   (`receivingAccountId`, `payoutAccountId`); clears the column. - **Value** — validated and applied. Required fields (`termId`,   `certStr`, `billerId`) reject an explicit `null` with 400.  `authToken` rotation is out of scope — it lives on the dedicated `POST .../auth-tokens` + `POST .../auth-tokens/{tokenId}/promote` endpoints. Sending `authToken` in this body returns 400.  Unknown keys and empty bodies are rejected with 400.  **FISERV_FORWARD** configurations accept exactly one key, `authFeeCents` (see `PatchFiservForwardGatewayConfigurationRequest`). Sending it on a PROPAY or GENERIC configuration, or sending a credential field on a Forward configuration, returns 400. GENERIC gateways have no patchable field and return 409. 
     * @summary Patch gateway configuration (PROPAY only)
     * @param {string} partnerId 
     * @param {string} id 
     * @param {PatchGatewayConfigurationV1Request} patchGatewayConfigurationV1Request 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GatewayConfigurationsApi
     */
    public patchGatewayConfigurationV1(partnerId: string, id: string, patchGatewayConfigurationV1Request: PatchGatewayConfigurationV1Request, options?: RawAxiosRequestConfig) {
        return GatewayConfigurationsApiFp(this.configuration).patchGatewayConfigurationV1(partnerId, id, patchGatewayConfigurationV1Request, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Atomically demote the current `LIVE` token to `RETIRED` and set the target token `LIVE`. Because the previous token is preserved as `RETIRED`, rollback is simply a promote of that retired token — there is no separate rollback endpoint.  Idempotent: promoting the already-LIVE token returns 200 with `previousLiveTokenId = null` and does not create a spurious RETIRED row.  Concurrency: two concurrent promotes on the same gateway serialise; the second observes the first\'s committed state and either becomes a no-op (when the winner already set its target LIVE) or promotes on top of the winner. 
     * @summary Promote a ProPay authToken to LIVE (rollback is a promote of the RETIRED token)
     * @param {string} partnerId 
     * @param {string} configId 
     * @param {string} tokenId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GatewayConfigurationsApi
     */
    public promoteGatewayAuthTokenV1(partnerId: string, configId: string, tokenId: string, options?: RawAxiosRequestConfig) {
        return GatewayConfigurationsApiFp(this.configuration).promoteGatewayAuthTokenV1(partnerId, configId, tokenId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Register a new ProPay `authToken` as a `STANDBY` version on this PROPAY gateway configuration. The current `LIVE` token is left untouched — every payment, void, refund, and onboarding call continues to resolve `LIVE` until an explicit promote. Multiple STANDBY rows may coexist; the single-LIVE invariant is unaffected.  Only applicable to PROPAY gateways. Duplicate token values (compared against ALL existing versions on this gateway — LIVE, STANDBY, and RETIRED) are rejected with 409 to prevent an operator from re-adding a value that was already recorded on this credential. 
     * @summary Rotate ProPay authToken (add STANDBY)
     * @param {string} partnerId 
     * @param {string} id 
     * @param {AddAuthTokenRequest} addAuthTokenRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GatewayConfigurationsApi
     */
    public rotateGatewayAuthTokenV1(partnerId: string, id: string, addAuthTokenRequest: AddAuthTokenRequest, options?: RawAxiosRequestConfig) {
        return GatewayConfigurationsApiFp(this.configuration).rotateGatewayAuthTokenV1(partnerId, id, addAuthTokenRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

